import isEqual from "lodash/isEqual";
import pick from "lodash/pick";
import { createDonation, updateDonation, transactionId } from "../../../redux/donationSlice";
import { logger } from "../../../utils/logger";

const FIELDS_TO_COMPARE = [
  "donorId",
  "transactionId",
  "firstName",
  "lastName",
  "mobile1",
  "mobile2",
  "bookNo",
  "receiptNo",
  "receiptDate",
  "payMode",
  "amount",
  "actualReceiptNo",
  "bankName",
  "instrumentNo",
  "instrumentDate",
  "upiId",
  "payPurpose",
  "tributeName",
  "sharma",
  "poojaDate",
  "tamilMonths",
  "nachathiram",
  "thithi",
  "utsavam",
  "donationRemarks",
  "complete",
];

/**
 * Normalize donation data for comparison
 */
const normalize = (obj) => {
  const copy = { ...obj };
  if (copy.amount) copy.amount = Number(copy.amount);
  if (copy.receiptDate)
    copy.receiptDate = new Date(copy.receiptDate).toISOString().split("T")[0];
  return copy;
};

/**
 * Handle save donation (create or update)
 */
export const handleSaveDonation = async (
  data,
  originalDonation,
  dispatch,
  user,
  setFeedback,
  handleCloseModal
) => {
  try {
    if (originalDonation?.transactionId) {
      // Update existing donation
      const original = normalize(pick(originalDonation, FIELDS_TO_COMPARE));
      const updated = normalize(pick(data, FIELDS_TO_COMPARE));

      if (isEqual(original, updated)) {
        setFeedback({
          open: true,
          message: "No changes detected",
          severity: "info",
        });
        return;
      }

      const response = await dispatch(updateDonation(data));
      const updatedonation = response.payload;

      if (!updatedonation.error) {
        setFeedback({
          open: true,
          message: "Donation updated successfully!",
          severity: "success",
        });
        logger.info("Donation updated successfully", {
          donorId: data.donorId,
          transactionId: data.transactionId,
          username: user?.username,
          role: user?.role,
          updatedDonation: data,
        });
        handleCloseModal();
      } else {
        setFeedback({
          open: true,
          message: "Error updating donation",
          severity: "error",
        });
        logger.error("Error occur in updating donation", {
          donorId: data?.donorId,
          error: updatedonation?.error,
          username: user?.username,
          role: user?.role,
        });
      }
    } else {
      // Create new donation
      const transactionResponse = await dispatch(transactionId(data));
      const newtransactionId = transactionResponse.payload;
      const copyData = { ...data, transactionId: newtransactionId };
      const response = await dispatch(createDonation(copyData));
      const newDonation = response.payload;

      if (!newDonation.error) {
        setFeedback({
          open: true,
          message: "New donation added successfully!",
          severity: "success",
        });
        logger.info("New donation added successfully", {
          donorId: data.donorId,
          transactionId: newDonation.transactionId || newtransactionId,
          username: user?.username,
          role: user?.role,
          donationData: copyData,
        });
        handleCloseModal();
      } else {
        setFeedback({
          open: true,
          message: "Error creating donation",
          severity: "error",
        });
        logger.error("Error occur in creating new donation", {
          donorId: data?.donorId,
          error: newDonation?.error,
          username: user?.username,
          role: user?.role,
        });
      }
    }
  } catch (error) {
    setFeedback({
      open: true,
      message: "An error occurred. Please try again.",
      severity: "error",
    });
    logger.error("Some technical error occur during donation form submission", {
      data,
      error: error,
      username: user?.username,
      role: user?.role,
    });
  }
};

/**
 * Handle edit donation click
 */
export const handleEditDonation = (donation, setEditData, setOpen) => {
  setEditData(donation);
  setOpen(true);
};

/**
 * Handle add donation data
 */
export const handleAddDonationData = (donor, setEditData, setIsOpenNew) => {
  setEditData(donor);
  setIsOpenNew(true);
};

/**
 * Handle modal close
 */
export const handleCloseModal = (setOpen, setIsOpenNew, setEditData) => {
  setOpen(false);
  setIsOpenNew(false);
  setEditData(null);
};

/**
 * Handle feedback close
 */
export const handleCloseFeedback = (feedback, setFeedback) => {
  setFeedback({ ...feedback, open: false });
};

/**
 * Handle modal submit (trigger form submission)
 */
export const handleModalSubmit = (formRef) => {
  if (formRef.current) {
    formRef.current.submitForm();
  }
};
